import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  de: {
    // Header & Navigation
    beratungAnfragen: 'Beratung anfragen',
    photovoltaik: 'Photovoltaik',
    industrie: 'Industrie',
    waermepumpe: 'Wärmepumpe',
    dachdecker: 'Dachdecker',
    wallbox: 'Wallbox',
    elektrik: 'Elektrik',
    partner: 'Partner',
    
    // Hero
    expertenBadge: 'Experten für erneuerbare Energien',
    heroTitle1: 'Energie der Zukunft –',
    heroTitle2: 'nachhaltig & effizient',
    heroDescription: 'Professionelle Photovoltaikanlagen, Wärmepumpen und Elektroinstallationen für Ihr Zuhause. Mit Gravante investieren Sie in Unabhängigkeit und Nachhaltigkeit.',
    kostenloseBeratung: 'Kostenlose Beratung',
    produkteEntdecken: 'Produkte entdecken',
    installationen: 'Installationen',
    jahreErfahrung: 'Jahre Erfahrung',
    zufriedenheit: 'Zufriedenheit',
    
    // Products Section
    unsereLeistungen: 'Unsere Leistungen',
    wasWirBieten: 'Was wir für Sie bieten',
    photovoltaikDesc: 'Hochwertige Solaranlagen für maximale Energieeffizienz',
    waermepumpeDesc: 'Effiziente Heizsysteme für Ihr Zuhause',
    wallboxDesc: 'Laden Sie Ihr Elektroauto bequem zu Hause',
    elektrikDesc: 'Professionelle Elektroinstallationen',
    dachdeckerDesc: 'Dachsanierung und Neueindeckung',
    mehrErfahren: 'Mehr erfahren',
    
    // Benefits Section
    warumGravante: 'Warum Gravante',
    ihreVorteile: 'Ihre Vorteile mit uns',
    qualitaet: 'Höchste Qualität',
    qualitaetDesc: 'Wir verwenden nur Premium-Komponenten führender Hersteller',
    erfahrung: 'Jahrelange Erfahrung',
    erfahrungDesc: 'Über 25 Jahre Expertise in erneuerbaren Energien',
    service: 'Rundum-Service',
    serviceDesc: 'Von der Planung bis zur Wartung - alles aus einer Hand',
    garantie: 'Langzeitgarantie',
    garantieDesc: 'Bis zu 25 Jahre Garantie auf Module und Installation',
    
    // Process Section
    soFunktioniert: 'So funktioniert es',
    inVierSchritten: 'In 4 Schritten zur eigenen Anlage',
    schritt1: 'Beratung',
    schritt1Desc: 'Kostenlose Erstberatung und Analyse Ihres Bedarfs',
    schritt2: 'Planung',
    schritt2Desc: 'Individuelle Planung Ihrer Anlage',
    schritt3: 'Installation',
    schritt3Desc: 'Professionelle Montage durch unser Team',
    schritt4: 'Inbetriebnahme',
    schritt4Desc: 'Anmeldung und Inbetriebnahme Ihrer Anlage',
    
    // Testimonials
    kundenstimmen: 'Kundenstimmen',
    wasKundenSagen: 'Was unsere Kunden sagen',
    
    // FAQ
    haeufigeFragen: 'Häufige Fragen',
    faqTitle: 'Antworten auf Ihre Fragen',
    
    // Contact Section
    kontakt: 'Kontakt',
    kontaktierenSieUns: 'Kontaktieren Sie uns',
    kontaktDesc: 'Haben Sie Fragen? Wir sind für Sie da!',
    name: 'Name',
    email: 'E-Mail',
    telefon: 'Telefon',
    nachricht: 'Nachricht',
    senden: 'Senden',
    adresse: 'Adresse',
    oeffnungszeiten: 'Öffnungszeiten',
    moFr: 'Mo-Fr',
    
    // Footer
    schnelllinks: 'Schnelllinks',
    leistungen: 'Leistungen',
    impressum: 'Impressum',
    datenschutz: 'Datenschutz',
    agb: 'AGB',
    alleRechteVorbehalten: 'Alle Rechte vorbehalten',
    ueberUns: 'Über uns',
    ueberUnsDesc: 'Ihr zuverlässiger Partner für erneuerbare Energien und Gebäudetechnik in der Region Stuttgart.',
    
    // Cookie Banner
    cookieTitle: 'Wir verwenden Cookies',
    cookieText: 'Wir verwenden Cookies für ein optimales Erlebnis.',
    cookieAccept: 'Akzeptieren',
    cookieDecline: 'Ablehnen',
    
    // Bill Scanner
    rechnungsScanner: 'Stromrechnung scannen',
    rechnungsScannerDesc: 'Laden Sie Ihre Stromrechnung hoch und erfahren Sie Ihr Sparpotenzial',
    dateiAuswaehlen: 'Datei auswählen',
    analysieren: 'Analysieren',
    ihrVerbrauch: 'Ihr Verbrauch',
    ihreKosten: 'Ihre Kosten',
    ihreSparnis: 'Ihre Ersparnis mit Solar',
    in20Jahren: 'Ersparnis in 20 Jahren',
    co2Ersparnis: 'CO₂-Ersparnis pro Jahr',
    
    // Solar Configurator
    solarKonfigurator: 'Solar-Konfigurator',
    konfiguratorDesc: 'Berechnen Sie Ihre optimale Solaranlage',
    dachflaeche: 'Dachfläche',
    jahresverbrauch: 'Jahresverbrauch',
    dachausrichtung: 'Dachausrichtung',
    dachneigung: 'Dachneigung',
    mitSpeicher: 'Mit Batteriespeicher',
    sueden: 'Süden',
    osten: 'Osten',
    westen: 'Westen',
    berechnen: 'Berechnen',
    empfohleneAnlage: 'Empfohlene Anlage',
    jahresproduktion: 'Jahresproduktion',
    eigenverbrauch: 'Eigenverbrauch',
    jaehrlicheErsparnis: 'Jährliche Ersparnis',
    amortisation: 'Amortisation',
    investition: 'Investition',
    
    // Live Energy Dashboard
    energieDashboard: 'Live Energie-Dashboard',
    dashboardDesc: 'Sehen Sie live, wie Solaranlagen in Ihrer Region arbeiten',
    aktuelleLeistung: 'Aktuelle Leistung',
    tagesproduktion: 'Tagesproduktion',
    gesamtErsparnis: 'Gesparte Stromkosten',
    co2Eingespart: 'CO₂ eingespart',
    
    // Industrie Page
    grossanlagen: 'Großanlagen ab 150 kWp',
    industriellePV: 'Industrielle Photovoltaik',
    industrieDesc: 'Maßgeschneiderte Solarlösungen für Industrie, Gewerbe und Logistik. Von der Planung bis zur schlüsselfertigen Übergabe – alles aus einer Hand.',
    kostenloseProjektberatung: 'Kostenlose Projektberatung',
    referenzenAnsehen: 'Referenzen ansehen',
    mwpInstalliert: 'MWp installiert',
    industrieprojekte: 'Industrieprojekte',
    durchschnittlicheErsparnis: 'Ø Ersparnis',
    warumPVUnternehmen: 'Warum Photovoltaik für Ihr Unternehmen?',
    investierenZukunft: 'Investieren Sie in die Zukunft Ihres Unternehmens mit nachhaltiger Energie',
    massiveKosteneinsparung: 'Massive Kosteneinsparung',
    kosteneinsparungDesc: 'Reduzieren Sie Ihre Stromkosten um bis zu 80%. Bei Großanlagen amortisiert sich die Investition oft in unter 5 Jahren.',
    co2Neutralitaet: 'CO2-Neutralität',
    co2Desc: 'Erreichen Sie Ihre Klimaziele und verbessern Sie Ihr Unternehmensimage mit grüner Energie.',
    wertsteigerung: 'Wertsteigerung',
    wertsteigerungDesc: 'Steigern Sie den Wert Ihrer Immobilie und sichern Sie sich langfristige Energieunabhängigkeit.',
    planungssicherheit: 'Planungssicherheit',
    planungssicherheitDesc: 'Schützen Sie sich vor steigenden Strompreisen mit eigenem Solarstrom für die nächsten 30+ Jahre.',
    anlagengroessen: 'Anlagengrößen & Eckdaten',
    mittelstand: 'Mittelstand',
    grossanlage: 'Industrie',
    grossprojekte: 'Großprojekte',
    beliebteste: 'BELIEBTESTE WAHL',
    leistungsspektrum: 'Unser Leistungsspektrum',
    schluesselfertig: 'Schlüsselfertige Komplettlösungen für Ihr Solarprojekt',
    planungEngineering: 'Planung & Engineering',
    installationMontage: 'Installation & Montage',
    serviceWartung: 'Service & Wartung',
    unsereReferenzen: 'Unsere Referenzen',
    erfolgreichProjekte: 'Erfolgreich realisierte Großprojekte',
    leistung: 'Leistung',
    ersparnis: 'Ersparnis',
    bereitEnergiewende: 'Bereit für Ihre Energiewende?',
    energiewendeDesc: 'Lassen Sie uns gemeinsam Ihr Solarprojekt planen. Kostenlose Erstberatung und individuelle Angebote.',
    projektanfrage: 'Projektanfrage stellen',
    projektanfrageDesc: 'Füllen Sie das Formular aus und wir melden uns innerhalb von 24 Stunden',
    firma: 'Firma',
    ansprechpartner: 'Ansprechpartner',
    geschaetzteDachflaeche: 'Geschätzte Dachfläche (m²)',
    stromverbrauch: 'Jahres-Stromverbrauch (kWh)',
    projektanfrageAbsenden: 'Projektanfrage absenden',
    anfrageerhalten: 'Anfrage erhalten!',
    anfrageerhaltennDesc: 'Vielen Dank für Ihr Interesse. Unser Industrie-Team wird sich innerhalb von 24 Stunden bei Ihnen melden.',
    zurueckStartseite: 'Zurück zur Startseite',
    
    // Beratung Page
    beratungTitle: 'Kostenlose Beratung',
    beratungDesc: 'Vereinbaren Sie einen kostenlosen Beratungstermin mit unseren Experten',
    systemTyp: 'System-Typ',
    nurPhotovoltaik: 'Nur Photovoltaik',
    nurWaermepumpe: 'Nur Wärmepumpe',
    beideSysteme: 'Beide Systeme',
    gebaeudeart: 'Gebäudeart',
    einfamilienhaus: 'Einfamilienhaus',
    mehrfamilienhaus: 'Mehrfamilienhaus',
    gewerbe: 'Gewerbe',
    heizungsart: 'Aktuelle Heizungsart',
    gas: 'Gas',
    oel: 'Öl',
    strom: 'Strom',
    sonstige: 'Sonstige',
    terminAnfragen: 'Termin anfragen',
    
    // Elektrik Page
    elektrikTitle: 'Elektroinstallationen',
    elektrikSubtitle: 'Professionelle Elektrotechnik für jeden Bedarf',
    hausinstallation: 'Hausinstallation',
    industrieElektrik: 'Industrieelektrik',
    smartHome: 'Smart Home',
    notdienst: 'Notdienst 24/7',
    
    // Wärmepumpe Page
    waermepumpeTitle: 'Wärmepumpen',
    waermepumpeSubtitle: 'Effizientes Heizen und Kühlen für Ihr Zuhause',
    luftWasser: 'Luft-Wasser',
    soleWasser: 'Sole-Wasser',
    wasserWasser: 'Wasser-Wasser',
    foerderung: 'Bis zu 70% Förderung',
    
    // Dachdecker Page
    dachdeckerTitle: 'Dacharbeiten',
    dachdeckerSubtitle: 'Professionelle Dachsanierung und Neueindeckung',
    dachsanierung: 'Dachsanierung',
    neueindeckung: 'Neueindeckung',
    flachdach: 'Flachdach',
    daemmung: 'Dämmung',
    
    // Wallbox Page
    wallboxTitle: 'Wallbox & E-Mobilität',
    wallboxSubtitle: 'Laden Sie Ihr Elektroauto bequem zu Hause',
    installation: 'Installation',
    foerderbar: 'Förderbar',
    
    // Partner Page
    partnerTitle: 'Partner werden',
    partnerSubtitle: 'Werden Sie Teil unseres Partnernetzwerks',
    partnerVorteile: 'Ihre Vorteile als Partner',
    jetztBewerben: 'Jetzt bewerben',
    
    // Common
    jetzt: 'Jetzt',
    hier: 'Hier',
    weiter: 'Weiter',
    zurueck: 'Zurück',
    abbrechen: 'Abbrechen',
    speichern: 'Speichern',
    laden: 'Wird geladen...',
    fehler: 'Fehler',
    erfolg: 'Erfolg',
    pro: 'pro',
    jahr: 'Jahr',
    jahre: 'Jahre',
    monat: 'Monat',
    tag: 'Tag',
    stunde: 'Stunde',
    kwh: 'kWh',
    kwp: 'kWp',
    euro: '€',
    qm: 'm²',
    grad: '°',
  },
  en: {
    // Header & Navigation
    beratungAnfragen: 'Request Consultation',
    photovoltaik: 'Photovoltaics',
    industrie: 'Industrial',
    waermepumpe: 'Heat Pump',
    dachdecker: 'Roofing',
    wallbox: 'Wallbox',
    elektrik: 'Electrical',
    partner: 'Partner',
    
    // Hero
    expertenBadge: 'Experts in Renewable Energy',
    heroTitle1: 'Energy of the Future –',
    heroTitle2: 'sustainable & efficient',
    heroDescription: 'Professional photovoltaic systems, heat pumps and electrical installations for your home. With Gravante, invest in independence and sustainability.',
    kostenloseBeratung: 'Free Consultation',
    produkteEntdecken: 'Discover Products',
    installationen: 'Installations',
    jahreErfahrung: 'Years Experience',
    zufriedenheit: 'Satisfaction',
    
    // Products Section
    unsereLeistungen: 'Our Services',
    wasWirBieten: 'What we offer you',
    photovoltaikDesc: 'High-quality solar systems for maximum energy efficiency',
    waermepumpeDesc: 'Efficient heating systems for your home',
    wallboxDesc: 'Charge your electric car conveniently at home',
    elektrikDesc: 'Professional electrical installations',
    dachdeckerDesc: 'Roof renovation and new roofing',
    mehrErfahren: 'Learn more',
    
    // Benefits Section
    warumGravante: 'Why Gravante',
    ihreVorteile: 'Your benefits with us',
    qualitaet: 'Highest Quality',
    qualitaetDesc: 'We only use premium components from leading manufacturers',
    erfahrung: 'Years of Experience',
    erfahrungDesc: 'Over 25 years of expertise in renewable energy',
    service: 'Full Service',
    serviceDesc: 'From planning to maintenance - everything from one source',
    garantie: 'Long-term Warranty',
    garantieDesc: 'Up to 25 years warranty on modules and installation',
    
    // Process Section
    soFunktioniert: 'How it works',
    inVierSchritten: 'In 4 steps to your own system',
    schritt1: 'Consultation',
    schritt1Desc: 'Free initial consultation and needs analysis',
    schritt2: 'Planning',
    schritt2Desc: 'Individual planning of your system',
    schritt3: 'Installation',
    schritt3Desc: 'Professional installation by our team',
    schritt4: 'Commissioning',
    schritt4Desc: 'Registration and commissioning of your system',
    
    // Testimonials
    kundenstimmen: 'Testimonials',
    wasKundenSagen: 'What our customers say',
    
    // FAQ
    haeufigeFragen: 'FAQ',
    faqTitle: 'Answers to your questions',
    
    // Contact Section
    kontakt: 'Contact',
    kontaktierenSieUns: 'Contact us',
    kontaktDesc: 'Do you have questions? We are here for you!',
    name: 'Name',
    email: 'Email',
    telefon: 'Phone',
    nachricht: 'Message',
    senden: 'Send',
    adresse: 'Address',
    oeffnungszeiten: 'Opening Hours',
    moFr: 'Mon-Fri',
    
    // Footer
    schnelllinks: 'Quick Links',
    leistungen: 'Services',
    impressum: 'Imprint',
    datenschutz: 'Privacy Policy',
    agb: 'Terms',
    alleRechteVorbehalten: 'All rights reserved',
    ueberUns: 'About Us',
    ueberUnsDesc: 'Your reliable partner for renewable energy and building technology in the Stuttgart region.',
    
    // Cookie Banner
    cookieTitle: 'We use Cookies',
    cookieText: 'We use cookies for an optimal experience.',
    cookieAccept: 'Accept',
    cookieDecline: 'Decline',
    
    // Bill Scanner
    rechnungsScanner: 'Scan Electricity Bill',
    rechnungsScannerDesc: 'Upload your electricity bill and find out your savings potential',
    dateiAuswaehlen: 'Choose File',
    analysieren: 'Analyze',
    ihrVerbrauch: 'Your Consumption',
    ihreKosten: 'Your Costs',
    ihreSparnis: 'Your Savings with Solar',
    in20Jahren: 'Savings in 20 Years',
    co2Ersparnis: 'CO₂ Savings per Year',
    
    // Solar Configurator
    solarKonfigurator: 'Solar Configurator',
    konfiguratorDesc: 'Calculate your optimal solar system',
    dachflaeche: 'Roof Area',
    jahresverbrauch: 'Annual Consumption',
    dachausrichtung: 'Roof Orientation',
    dachneigung: 'Roof Pitch',
    mitSpeicher: 'With Battery Storage',
    sueden: 'South',
    osten: 'East',
    westen: 'West',
    berechnen: 'Calculate',
    empfohleneAnlage: 'Recommended System',
    jahresproduktion: 'Annual Production',
    eigenverbrauch: 'Self-consumption',
    jaehrlicheErsparnis: 'Annual Savings',
    amortisation: 'Payback Period',
    investition: 'Investment',
    
    // Live Energy Dashboard
    energieDashboard: 'Live Energy Dashboard',
    dashboardDesc: 'See live how solar systems in your region are performing',
    aktuelleLeistung: 'Current Power',
    tagesproduktion: 'Daily Production',
    gesamtErsparnis: 'Saved Electricity Costs',
    co2Eingespart: 'CO₂ Saved',
    
    // Industrie Page
    grossanlagen: 'Large-scale systems from 150 kWp',
    industriellePV: 'Industrial Photovoltaics',
    industrieDesc: 'Customized solar solutions for industry, commerce and logistics. From planning to turnkey handover – everything from one source.',
    kostenloseProjektberatung: 'Free Project Consultation',
    referenzenAnsehen: 'View References',
    mwpInstalliert: 'MWp installed',
    industrieprojekte: 'Industrial Projects',
    durchschnittlicheErsparnis: 'Avg. Savings',
    warumPVUnternehmen: 'Why Photovoltaics for Your Business?',
    investierenZukunft: 'Invest in the future of your company with sustainable energy',
    massiveKosteneinsparung: 'Massive Cost Savings',
    kosteneinsparungDesc: 'Reduce your electricity costs by up to 80%. Large-scale systems often pay for themselves in under 5 years.',
    co2Neutralitaet: 'CO2 Neutrality',
    co2Desc: 'Achieve your climate goals and improve your company image with green energy.',
    wertsteigerung: 'Value Increase',
    wertsteigerungDesc: 'Increase the value of your property and secure long-term energy independence.',
    planungssicherheit: 'Planning Security',
    planungssicherheitDesc: 'Protect yourself from rising electricity prices with your own solar power for the next 30+ years.',
    anlagengroessen: 'System Sizes & Key Data',
    mittelstand: 'Medium Business',
    grossanlage: 'Industry',
    grossprojekte: 'Large Projects',
    beliebteste: 'MOST POPULAR',
    leistungsspektrum: 'Our Range of Services',
    schluesselfertig: 'Turnkey complete solutions for your solar project',
    planungEngineering: 'Planning & Engineering',
    installationMontage: 'Installation & Assembly',
    serviceWartung: 'Service & Maintenance',
    unsereReferenzen: 'Our References',
    erfolgreichProjekte: 'Successfully realized large-scale projects',
    leistung: 'Power',
    ersparnis: 'Savings',
    bereitEnergiewende: 'Ready for Your Energy Transition?',
    energiewendeDesc: "Let's plan your solar project together. Free initial consultation and individual offers.",
    projektanfrage: 'Submit Project Inquiry',
    projektanfrageDesc: 'Fill out the form and we will get back to you within 24 hours',
    firma: 'Company',
    ansprechpartner: 'Contact Person',
    geschaetzteDachflaeche: 'Estimated Roof Area (m²)',
    stromverbrauch: 'Annual Electricity Consumption (kWh)',
    projektanfrageAbsenden: 'Submit Project Inquiry',
    anfrageerhalten: 'Inquiry Received!',
    anfrageerhaltennDesc: 'Thank you for your interest. Our industrial team will contact you within 24 hours.',
    zurueckStartseite: 'Back to Homepage',
    
    // Beratung Page
    beratungTitle: 'Free Consultation',
    beratungDesc: 'Schedule a free consultation with our experts',
    systemTyp: 'System Type',
    nurPhotovoltaik: 'Photovoltaics Only',
    nurWaermepumpe: 'Heat Pump Only',
    beideSysteme: 'Both Systems',
    gebaeudeart: 'Building Type',
    einfamilienhaus: 'Single Family House',
    mehrfamilienhaus: 'Multi-Family House',
    gewerbe: 'Commercial',
    heizungsart: 'Current Heating Type',
    gas: 'Gas',
    oel: 'Oil',
    strom: 'Electric',
    sonstige: 'Other',
    terminAnfragen: 'Request Appointment',
    
    // Elektrik Page
    elektrikTitle: 'Electrical Installations',
    elektrikSubtitle: 'Professional electrical engineering for every need',
    hausinstallation: 'Home Installation',
    industrieElektrik: 'Industrial Electrical',
    smartHome: 'Smart Home',
    notdienst: 'Emergency Service 24/7',
    
    // Wärmepumpe Page
    waermepumpeTitle: 'Heat Pumps',
    waermepumpeSubtitle: 'Efficient heating and cooling for your home',
    luftWasser: 'Air-Water',
    soleWasser: 'Brine-Water',
    wasserWasser: 'Water-Water',
    foerderung: 'Up to 70% Subsidy',
    
    // Dachdecker Page
    dachdeckerTitle: 'Roofing Work',
    dachdeckerSubtitle: 'Professional roof renovation and new roofing',
    dachsanierung: 'Roof Renovation',
    neueindeckung: 'New Roofing',
    flachdach: 'Flat Roof',
    daemmung: 'Insulation',
    
    // Wallbox Page
    wallboxTitle: 'Wallbox & E-Mobility',
    wallboxSubtitle: 'Charge your electric car conveniently at home',
    installation: 'Installation',
    foerderbar: 'Eligible for Subsidy',
    
    // Partner Page
    partnerTitle: 'Become a Partner',
    partnerSubtitle: 'Become part of our partner network',
    partnerVorteile: 'Your Benefits as a Partner',
    jetztBewerben: 'Apply Now',
    
    // Common
    jetzt: 'Now',
    hier: 'Here',
    weiter: 'Continue',
    zurueck: 'Back',
    abbrechen: 'Cancel',
    speichern: 'Save',
    laden: 'Loading...',
    fehler: 'Error',
    erfolg: 'Success',
    pro: 'per',
    jahr: 'Year',
    jahre: 'Years',
    monat: 'Month',
    tag: 'Day',
    stunde: 'Hour',
    kwh: 'kWh',
    kwp: 'kWp',
    euro: '€',
    qm: 'm²',
    grad: '°',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'de';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
